// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"index_breadcrumbs_3GYMv","current":"index_current_1c9rQ","arrow":"index_arrow_1C8L0"};